import PropTypes from "prop-types";
import SoftTypography from "components/SoftTypography";
import SoftBox from "components/SoftBox";
import SoftInput from "components/SoftInput";
import { Chip, Grid, MenuItem, OutlinedInput, Select, Stack } from "@mui/material";
import { useRef, useState } from "react";
import StyledTextarea from "components/StyledTextarea";

function BlogCategoryAddEdit({ currentCategoryData, allCategories }) {
    const editorRef = useRef(null);
    const [defaultParentId, setDefaultParentId] = useState(currentCategoryData.parent_id);
    const [allKeywords, setAllKeywords] = useState(currentCategoryData.seo_keywords);
    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
                width: 250,
            },
        },
    };

    return <>
        <SoftBox component="form" role="form" style={{
            "margin": "0 16px"
        }}>
            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                <Grid item xs={6}>
                    <SoftBox mb={2}>
                        <SoftBox mb={1} ml={0.5}>
                            <SoftTypography component="label" variant="caption" fontWeight="bold">
                                Category Name
                            </SoftTypography>
                        </SoftBox>
                        <SoftInput
                            type="text"
                            placeholder="Category Name"
                            defaultValue={currentCategoryData.name}
                            onChange={(event) => currentCategoryData.name = event.target.value} />
                    </SoftBox>
                </Grid>
                <Grid item xs={6}>
                    <SoftBox mb={2}>
                        <SoftBox mb={1} ml={0.5}>
                            <SoftTypography component="label" variant="caption" fontWeight="bold">
                                Parent Category
                            </SoftTypography>
                        </SoftBox>
                        <Select
                            displayEmpty
                            value={defaultParentId}
                            onChange={(event) => {
                                currentCategoryData.parent_id = event.target.value;
                                setDefaultParentId(currentCategoryData.parent_id);
                            }}
                            input={<OutlinedInput />}
                            MenuProps={MenuProps}
                        >
                            <MenuItem value="0">
                                Select Parent Category
                            </MenuItem>
                            {allCategories.map((singleCategory) => (
                                singleCategory.id !== currentCategoryData.id && singleCategory.parent_id !== currentCategoryData.id && <MenuItem
                                    key={singleCategory.id}
                                    value={singleCategory.id}
                                >
                                    {singleCategory.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </SoftBox>
                </Grid>
            </Grid>
            <Grid container rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
                <Grid item xs={6}>
                    <SoftBox mb={2}>
                        <SoftBox mb={1} ml={0.5}>
                            <SoftTypography component="label" variant="caption" fontWeight="bold">
                                SEO Title
                            </SoftTypography>
                        </SoftBox>
                        <SoftInput
                            type="text"
                            placeholder="SEO Title"
                            defaultValue={currentCategoryData.seo_title}
                            onChange={(event) => currentCategoryData.seo_title = event.target.value} />
                    </SoftBox>
                </Grid>
                <Grid item xs={6}>
                    <SoftBox mb={2}>
                        <SoftBox mb={1} ml={0.5}>
                            <SoftTypography component="label" variant="caption" fontWeight="bold">
                                SEO Keywords
                            </SoftTypography>
                        </SoftBox>
                        <SoftInput
                            type="text"
                            placeholder="SEO Keywords"
                            onKeyDown={(event) => {
                                if (event.key === 'Enter') {
                                    currentCategoryData.seo_keywords.push(event.target.value);
                                    setAllKeywords(currentCategoryData.seo_keywords);
                                    event.target.value = '';
                                }
                            }} />

                        {
                            allKeywords.length > 0 && <SoftBox mt={1} ml={0.5}>
                                <Stack direction="row" spacing={1} style={{ 'flexWrap': 'wrap' }}>
                                    {
                                        allKeywords.map((singleSeoKeyword) => (
                                            <Chip
                                                label={singleSeoKeyword}
                                                onDelete={() => {
                                                    currentCategoryData.seo_keywords = currentCategoryData.seo_keywords.filter((seoKeyword) => seoKeyword !== singleSeoKeyword);
                                                    setAllKeywords(currentCategoryData.seo_keywords);
                                                }}
                                                key={singleSeoKeyword} />
                                        ))
                                    }
                                </Stack>
                            </SoftBox>
                        }
                    </SoftBox>
                </Grid>
            </Grid>
            <SoftBox mb={2}>
                <SoftBox mb={1} ml={0.5}>
                    <SoftTypography component="label" variant="caption" fontWeight="bold">
                        SEO Description
                    </SoftTypography>
                </SoftBox>
                <StyledTextarea
                    aria-label="minimum height"
                    minRows={5}
                    placeholder="SEO Description"
                    defaultValue={currentCategoryData.seo_description}
                    onChange={(event) => currentCategoryData.seo_description = event.target.value} />
            </SoftBox>
        </SoftBox>
    </>;
}
BlogCategoryAddEdit.defaultProps = {
    currentCategoryData: {},
    allCategories: [],
};
BlogCategoryAddEdit.propTypes = {
    currentCategoryData: PropTypes.any.isRequired,
    allCategories: PropTypes.array.isRequired,
};

export default BlogCategoryAddEdit;